import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import { allTrueR } from '@uirouter/angularjs';

export const campaignStates = {
   parent: 'app',
   name: 'campaign',
   abstract: true,
   data: {
      roles: 'SuperAdmin,OrgAdmin,BrandManager,CampaignManager',
      nav: {
         title: 'Campaign',
         icon: 'e360-icon-campaign',
         children: [
            {
               title: 'Experiences',
               stateName: 'campaign.experiences',
               otherStates: [ 'campaign.experienceEdit' ]
            },
            {
               title: 'Details',
               stateName: 'campaign.edit',
               otherStates: [ 'campaign.add' ]
            },
            { title: 'Guest Types', stateName: 'campaign.guestTypes' }
         ]
      }
   }
};

export const campaignEditState = {
   name: 'campaign.edit',
   url: '/campaign/:id?youtube_deny',
   params: {
      id: {
         squash: true,
         value: null
      },
      tab: {
         type: 'int',
         value: 0
      },
      brand: {
        squash: true,
        value: null
      },
      org: {
        squash: true,
        value: null
      }
   },
   templateUrl: require('./campaign-edit.html'),
   controller: 'CampaignEditController as ctrl'
};

export const campaignAddState = {
   name: 'campaign.add',
   url: '/campaign/add',
   params: {
     brand: {
       squash: true,
       value: null
     },
     org: {
       squash: true,
       value: null
     }
   },
   templateUrl: require('./campaign-edit.html'),
   controller: 'CampaignEditController as ctrl'
};

ng.module('e360').config(configRoutes);

configRoutes.$inject = ['$stateRegistryProvider'];
function configRoutes($stateRegistry:uir.StateRegistry) {
   $stateRegistry.register(campaignStates);
   $stateRegistry.register(campaignEditState);
   $stateRegistry.register(campaignAddState);
}
